module.exports = __webpack_public_path__ + "static/img/p4.d7008d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p4.jpg
// module id = Wujy
// module chunks = 1